import { RegExpUtility } from "../../text/RegExpUtility";
import { EditingKeys } from "./EditingKeys";
import { ModifierKeys } from "./ModifierKeys";
import { NavigationKeys } from "./NavigationKeys";

export class Keys
{
  static isText( key:string )
  {
    if ( ModifierKeys.is( key ) )
    {
      return false;
    }

    if ( NavigationKeys.is( key ) )
    {
      return false;
    }

    if ( EditingKeys.is( key ) )
    {
      return false;
    }


    return true;
  } 
}